import { render, staticRenderFns } from "./CustomerGenders.vue?vue&type=template&id=faa5458a"
import script from "./CustomerGenders.vue?vue&type=script&lang=js"
export * from "./CustomerGenders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports